<script lang="ts">
  import { taxonomyOptions, categoryValue, type TaxonomyGroup } from './catalogue-helpers';
  let { groups, legacy = [], disabledValues = [] }: { groups: TaxonomyGroup[]; legacy?: string[]; disabledValues?: string[] } = $props();
  const options = $derived(taxonomyOptions(groups, legacy));
</script>
{#each options.groups as group}
  <optgroup label={group.category}>
    {#if !group.subcategories.length}<option value={group.category} disabled={disabledValues.includes(group.category)}>{group.category}</option>{/if}
    {#each group.subcategories as sub}<option value={categoryValue(group.category, sub)} disabled={disabledValues.includes(categoryValue(group.category, sub))}>{sub}</option>{/each}
  </optgroup>
{/each}
{#if options.legacy.length}<optgroup label="Existing categories">{#each options.legacy as value}<option {value}>{value}</option>{/each}</optgroup>{/if}
